import { render, staticRenderFns } from "./Loading.vue?vue&type=template&id=6b24a9c0"
import script from "./Loading.vue?vue&type=script&lang=ts"
export * from "./Loading.vue?vue&type=script&lang=ts"
import style0 from "./Loading.vue?vue&type=style&index=0&id=6b24a9c0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports